import { useState } from "react";
import { Link } from "react-router-dom";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("إن كان البريد مسجلًا، ستستلم رابطًا لإعادة التعيين");
    } catch (err) {
      toast.error(extractError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-4 sm:p-6">
      <div className="max-w-md sm:max-w-lg w-full space-y-6 bg-card p-6 sm:p-10 rounded-2xl border shadow-sm">
        <div>
          <h1 className="text-xl sm:text-2xl font-display font-semibold mb-2">نسيت كلمة المرور؟</h1>
          <p className="text-muted-foreground text-sm">أدخل بريدك وسنرسل لك رابطًا لإعادة التعيين.</p>
        </div>
        {sent ? (
          <div className="p-4 bg-secondary rounded-lg text-sm">تم إرسال الرابط إذا كان البريد مسجلًا. تحقّق من صندوق الرسائل.</div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div className="space-y-2">
              <Label>البريد الإلكتروني</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full" data-testid="forgot-submit">
              {loading ? "جارٍ الإرسال..." : "إرسال الرابط"}
            </Button>
          </form>
        )}
        <div className="text-center text-sm"><Link to="/login" className="text-primary hover:underline">العودة لتسجيل الدخول</Link></div>
      </div>
    </div>
  );
}
